import React, { useState, useRef, useCallback, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Autocomplete, Marker } from "@react-google-maps/api";
import { TextField, Box, Typography } from "@mui/material";
import { GOOGLE_MAPS_API_KEY } from "config/maps";

const containerStyle = {
  width: '100%',
  height: '300px',
};

const defaultCenter = {
  lat: 6.9271,
  lng: 79.8612,
};

const libraries = ['places'];

const LocationPicker = ({ value, onChange }) => {
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [markerPosition, setMarkerPosition] = useState(null);
  const autocompleteRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
  });

  useEffect(() => {
    if (value) {
      const [lat, lng] = value.split(',').map(Number);
      setMapCenter({ lat, lng });
      setMarkerPosition({ lat, lng });
    }
  }, [value]);

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const coord = `${lat},${lng}`;
        setMapCenter({ lat, lng });
        setMarkerPosition({ lat, lng });
        onChange(coord);
      }
    }
  };

  const handleMapClick = useCallback((event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const coord = `${lat},${lng}`;
    setMarkerPosition({ lat, lng });
    onChange(coord);
  }, [onChange]);

  if (!isLoaded) return <Typography>Loading Map...</Typography>;

  return (
    <Box>
      <Typography variant="subtitle2" mb={1}>Your Base Location (used to assign nearby pickups)</Typography>
      <Autocomplete
        onLoad={(ref) => (autocompleteRef.current = ref)}
        onPlaceChanged={onPlaceChanged}
      >
        <TextField fullWidth label="Search Location" variant="outlined" size="small" sx={{ mb: 2 }} />
      </Autocomplete>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={mapCenter}
        zoom={12}
        onClick={handleMapClick}
      >
        {markerPosition && <Marker position={markerPosition} />}
      </GoogleMap>

      <TextField
        fullWidth
        label="Selected Coordinates"
        variant="standard"
        sx={{ mt: 2 }}
        value={value}
        InputProps={{ readOnly: true }}
      />
    </Box>
  );
};

export default LocationPicker;
